<template>
  <div class="manage_date" v-if="clazz">
    <clazz-show-header :clazz="clazz" />

    <van-tabs v-model="active" color="#f5222d">
      <record-tab :title="'已通过(' + stat.total + ')'"
        :status="1"
        :reset="reset"
        @refresh="onRefresh"
      />
      <record-tab
        :title="'未审核(' + stat.wait + ')'"
        :review_status="1"
        :reset="reset"
        @refresh="onRefresh"
      />
      <record-tab
        :title="'未通过(' + stat.fail + ')'"
        :review_status="3"
        :reset="reset"
        @refresh="onRefresh"
      />
    </van-tabs>
  </div>
</template>

<script>
import { Tab, Tabs } from 'vant'
import ClazzShowHeader from '@/views/clazz/components/ClazzShowHeader'
import RecordTab from './components/RecordTab'
import { clazzSimpleInfo } from '@/api/clazz'
import { clazzRecordStat } from '@/api/record'

export default {
  name: 'ManageData',
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    ClazzShowHeader,
    RecordTab
  },
  data () {
    return {
      active: 0,
      clazz: null,
      reset: false,
      stat: {
        total: '',
        wait: '',
        fail: ''
      }
    }
  },
  created () {
    this.clazzId = this.$route.params.clazz_id || ''
    this.getClazzInfo(this.clazzId)
    this.getRecordStat(this.clazzId)
  },
  methods: {
    async getClazzInfo (clazzId) {
      let response = await clazzSimpleInfo(clazzId)
      if (!response.data.is_manager) {
        this.$router.replace('/explore')
        return false
      }
      this.clazz = response.data
    },
    async getRecordStat (clazzId) {
      let response = await clazzRecordStat(clazzId)
      this.stat = response.data
      this.reset = false
    },
    onRefresh () {
      this.reset = true
      this.getRecordStat(this.clazzId)
    }
  }
}
</script>

<style scoped lang="scss">
.manage_date {
  // background-color: #f8f8f8;
  .clazz_header {
    padding: 20px 30px;
    background: #02acaa;
    color: #fff;
    .title {
      font-size: 36px;
      margin-bottom: 15px;
    }
    .intro {
      font-size: 26px;
      display: flex;
      align-items: center;
      .headimg {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 1PX solid #fff;
      }
    }
  }
}
</style>
